baseApp.service('DiscoveryQueryService', [function() {

	var queryOperators = {
		is: {
			descriptor: 'is',
			spec: 'mustMatchPhrase',
			type: 'value'
		},
		is_not: {
			descriptor: 'is not',
			spec: 'mustNotMatchPhrase',
			type: 'value'
		},
		exists: {
			descriptor: 'exists',
			spec: 'mustExist',
			type: 'boolean'
		},
		not_exists: {
			descriptor: 'does not exists',
			spec: 'mustNotExist',
			type: 'boolean'
		},
		in: {
			descriptor: 'in',
			spec: 'mustBeIn',
			type: 'list'
		},
		not_in: {
			descriptor: 'not in',
			spec: 'mustNotBeIn',
			type: 'list'
		},
		between: {
			descriptor: 'between',
			spec: 'mustBeBetween',
			type: 'range'
		},
		not_between: {
			descriptor: 'not between',
			spec: 'mustNotBeBetween',
			type: 'range'
		},
	};

	var singularOperators = ['is', 'is_not', 'exists', 'not_exists', 'in', 'not_in'];
	var rangeOperators = ['is', 'is_not', 'exists', 'not_exists', 'in', 'not_in', 'between', 'not_between'];

	var fieldTypeToSupportedOperators = {
		keyword: singularOperators,
		link: singularOperators,
		date: rangeOperators,
		number: rangeOperators,
		ip: rangeOperators,
		text: [],
		country: singularOperators,
		bool: ['is', 'is_not', 'exists', 'not_exists'], // 'in' / 'not_in' don't make sense for bool
	};

	var discoveryQueryService = {};

	discoveryQueryService.getOperatorDefinition = function(operator) {
		return queryOperators[operator];
	}

	discoveryQueryService.getOperatorsForFieldType = function(type) {
		let res = []
		fieldTypeToSupportedOperators[type].forEach((item) => res.push({
			id: item,
			descriptor: queryOperators[item].descriptor,
			type: queryOperators[item].type
		}));
		return res;
	}

	/*
	 * Fetching all signatures which have a feed_type: "IP" in their metadata
	 * For events of type IPS, when showing the popup for such events, the IP will be shown instead of the domain.
	 */
	discoveryQueryService.loadFeedTypeIpSignatures = function() {
		store.fetch({
			path: '/getFeedTypeIpSignatures',
			success: function(data) {
				discoveryQueryService.feedTypeIpSignatures = {}
				data.forEach((signature_id) => discoveryQueryService.feedTypeIpSignatures[signature_id] = 1);
			}
		});
	}


	return discoveryQueryService;
}]);
